module.exports = __webpack_public_path__ + "static/img/bw.fee2051b.svg";